import { connect } from 'react-redux';
import { initGroupsPanel, addToGroupFolder, } from '../../../AddToGroupsPanel/redux/actions';
import { getHasOnlyOneChunkOfGroupsToLoad, getHasNoGroups, } from '../../../AddToGroupsPanel/redux/selectors';
var mapStateToProps = function (state) { return ({
    hasNoGroups: getHasNoGroups(state),
    hasOnlyOneChunkOfGroupsToLoad: getHasOnlyOneChunkOfGroupsToLoad(state),
}); };
var mapDispatchToProps = {
    initGroupsPanel: initGroupsPanel,
    addToGroupFolder: addToGroupFolder,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=AddToGroupPopup.container.js.map